import { AxiosInstance } from 'axios';
import {
  Preset, QuotaAndGroupUsage,
  UsageRepositoryInterface,
  UserCpuResult, WebsiteGroupBandwidthUsage,
} from '@/services/Usage/interfaces';

export default class UsageRepository implements UsageRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance
  ) {

  }

  public async getCpuUsage(userId: string, range: Preset): Promise<UserCpuResult> {
    // base url service is /cpu, so endpoint below becomes: /cpu/usage?range=24h
    const res = await this.axios.get(`/cpu/${userId}`, {
      params: { preset: range },
    });
    return res.data;
  }

  public async getDiskUsageByGroup(groupId: number): Promise<QuotaAndGroupUsage> {
    const { data } = await this.axios.get(`/disk-usage/usage`, {
      params: { groupId: groupId },
    });
    return data;
  }

  public async getDiskUsageBySystemUser(systemUserId: number): Promise<QuotaAndGroupUsage> {
    const { data } = await this.axios.get(`/disk-usage/usage`,
      {
        params: { systemUserId: systemUserId },
      });
    return data;
  }

  public async syncWebsiteGroupDiskUsageByGroupId(groupId: number): Promise<void> {
    await this.axios.post(`/disk-usage/usage`, {
      groupId: groupId,
    })
  }

  public async getBandwidthUsageByGroup(groupId: number, from: number): Promise<WebsiteGroupBandwidthUsage> {
    const { data } = await this.axios.get('/bandwidth/usage', {
      params: { groupId, from },
    });

    return data;
  }
}
